import { useContext, useEffect, useState } from "react";
import "./DarshanTemple.css";
import { FaqModuleID, ServiceDiscounts } from "../enum";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { t } from 'i18next';
import DatePicker from "react-date-picker";
import Select from "react-select";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import { customSelectStyles, SelectIdProof, SelectLanguageOptions } from "../../middlewares/Utils";
import { GetPanditListDataAPI } from "../../ApiServices/PanditList/PanditList";
import CODModal from "../../Pages/PanditBooking/CODModal";
import axios from "axios";

import { AddUpdateTempleDarshanBooking } from '../../ApiServices/Temple Darshan Booking/TempleDarshanBookingApi';

import { Tooltip } from "@mui/material";
import {
  BaseUrl,
  GetPhonePayPaymentLink,
  NewUpdatedBaseUrl,

} from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import "../../Pages/Stepper Form/stepper.css";
import TempleCodModal from "./TempleCodModal";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../CouponModal";
import { GetTimeSlotLookupList } from "../../ApiServices/Time Slot/TimeSlotApi";
const steps = [
  "Booking Details",
  // "Show Details",
  "Booking Preview",
  "Payment Status",
];

const TempleBookingForm = () => {
  const [selectedIdProof, setSelectedIdProof] = useState(1);
  const [currentStep, setCurrentStep] = useState(0);
  const [showCODModal, setShowCODModal] = useState(null);
  const [selectedPandit, setSelectedPandit] = useState(null);
  const [orderID, setOrderID] = useState();
  const [error, setError] = useState(null);
  const [panditDataList, setPanditDataList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;
  const [timeSlotOption, setTimeSlotOption] = useState([]);
  const [totals, setTotals] = useState({
    totalPrice: 0,
    totalConvienceFee: 0,
    GrandTotal: 0,
  });
  const [showMembers, setShowMembers] = useState(false);
  const { setLoader } =
    useContext(LoaderContext);
  const [templeBookingObj, setTempleBookingObj] = useState({
    time: null,
    languageID: null,
    landmark: null,

    pincode: null,
    ID_PROOF: 1,
    needSamagri: null,
    TR_ID: null,

    darshanPrice: null,
    TRB_TOTALPRICE: null,
    REFERAN_CODE: null,
    iDProofNo: null,
    bookingDate: null,
    darshanTimeSlotMapID: null,
    PAYMENT_TYPE: null,
    transactionID: null,
    paymentStatus: null,

    convenienceFee: null,
    taxAmount: null,
    EXTRA: null,

    AGE: null,
    templeDarshanSeatMapping: [],
    GENDERID: null,
    contactNumber: null,
    personName: null,



    userKeyID: null,
    darshanBookingKeyID: null,
    address: null,
    noOfSeats: null,
    templeDarshanID: null,
    idProofID: null,
    paymentTypeID: null,
    darshanPrice: null,
    taxAmount: null,
    convenienceTaxPercent: null,
    convenienceFee: null,
    paymentStatus: null,
    transactionID: null,
    transactionAmount: null,
    couponCodeID: null,
    couponCodeAmount: null,
    walletAmount: null,
    applicationType: null,
    templeDarshanSeatMapping: []
  });
  const [modelRequestData, setModelRequestData] = useState({
    totalPrice: null,
    amountEntered: null,
    convenienceFeeAddedWithTax: null,
    moduleName: null,
    couponCode: null
  });
  const userKeyID = localStorage.getItem("userKeyID");
  const genderOptions = [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" },
  ];
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    couponCode: null,
    isApplied: false,
    couponAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });
  const [isWalletApplied, setIsWalletApplied] = useState(false);

  const fromDate = dayjs();

  const userID = localStorage.getItem("userID");
  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(0)

  const product = location.state?.product;
  const langID = location.state?.langID;
  const pujaDetails = location.state;

  const [couponObj, setCouponObj] = useState({
    userID: userID,
    serviceID: FaqModuleID?.DarshanBooking,
    subModuleID: [location?.state?.TR_ID],
    orderAmount: Math.round(totals?.totalPrice)

  })
  useEffect(() => {


    setTotals((prev) => ({
      ...prev,
      totalPrice: Math.round(
        Number(templeBookingObj?.noOfSeats || 1) *
        Number(location?.state?.darshanPrice)
      ),
      totalConvienceFee: Math.round(
        Number(location?.state?.convenienceFee) +
        Number(location?.state?.convinienceFeeTaxAmount)
      ),
    }));
    setCouponObj((prev) => ({
      ...prev, orderAmount: Math.round(
        Number(templeBookingObj?.noOfSeats) *
        Number(location?.state?.darshanPrice)
      )
    }))

  }, []);







  useEffect(() => {
    GetPanditListData();
    GetUserWalletAmountData()
  }, []);
  useEffect(() => {
    if (isWalletApplied && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(Number(totals?.totalPrice), walletAmount);
      const discountAmount = Math.round(minAmount * 0.5);

      if (appliedCoupon?.walletAmount !== discountAmount) {
        setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }));
        setCouponAmount(discountAmount);
      }

    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.couponAmount);

    } else if (isWalletApplied === false && appliedCoupon?.isApplied === false) {
      setCouponAmount(0);

      if (appliedCoupon?.walletAmount !== 0) {
        setAppliedCoupon((prev) => ({ ...prev, walletAmount: 0 }));
      }
    }
  }, [isWalletApplied, appliedCoupon, totals?.totalPrice, walletAmount]);


  const handleGenderChange = (selectedOption) => {

    setTempleBookingObj((prev) => {
      const updatedBookingDetails = [...prev.templeDarshanSeatMapping];

      if (updatedBookingDetails.length > 0) {
        updatedBookingDetails[0] = {
          ...updatedBookingDetails[0],
          genderID: selectedOption ? selectedOption.value : null, // 👈 update only name
        };
      }

      return {
        ...prev,
        GENDERID: selectedOption ? selectedOption.value : null,
        templeDarshanSeatMapping: updatedBookingDetails,
      };
    });


  };



  const totalBeforeTax = Math.round(
    Number(templeBookingObj.noOfSeats) * Number(location.state.darshanPrice) +
    Number(location?.state?.convenienceFee)
  );

  const DynamicTax = Math.ceil(
    (totalBeforeTax * Number(ServiceDiscounts?.DailyBookingDiscount)) / 100
  );

  // const totalPrice1 = totalBeforeTax + DynamicTax;
  const totalPrice1 = Math.round(
    (totals?.totalPrice + totals?.totalConvienceFee) - couponAmount

  );
  const convenienceFeeAddedWithTax = Math.round(
    Number(location.state.convenienceFee) +
    Number(location?.state?.convinienceFeeTaxAmount)
  );



  useEffect(() => {
    if (!templeBookingObj?.noOfSeats || !location?.state) return;

    const totalPrice = Math.round(
      Number(templeBookingObj.noOfSeats) * Number(location.state.darshanPrice)
    );

    const totalConvienceFee = Math.round(
      Number(location.state.convenienceFee) +
      Number(location.state.convinienceFeeTaxAmount)
    );

    setTotals({
      totalPrice,
      totalConvienceFee,
      GrandTotal: totalPrice + totalConvienceFee,
    });

    // also update couponObj orderAmount based on new seat count
    setCouponObj((prev) => ({
      ...prev,
      orderAmount: totalPrice,
    }));
  }, [templeBookingObj.noOfSeats, location?.state]);


  const GetPanditListData = async () => {
    try {
      const response = await GetPanditListDataAPI(
        userID,
        location?.state?.product?.PUJA_ID,

        {
          START: 1,
          END: 10,
          WORD: "None",
          LATITUDE: "20.0086678",
          LONGITUDE: "73.7639264",
        }
      );

      if (response) {
        setPanditDataList(response.DATA);
      }
    } catch (error) {
      console.log(error);
    }
  };



  const HandleTempleDarshanBookingBtnClicked = () => {

    let isValid = false;
    const numSeats = parseInt(templeBookingObj.noOfSeats, 10);

    if (
      templeBookingObj.bookingDate === null ||
      templeBookingObj.bookingDate === undefined ||
      templeBookingObj.bookingDate === "" ||
      templeBookingObj.noOfSeats <= 0 ||
      // templeBookingObj.noOfSeats === undefined ||
      // templeBookingObj.noOfSeats === "" ||
      templeBookingObj.AGE === null ||
      templeBookingObj.AGE === undefined ||
      templeBookingObj.AGE === "" ||
      templeBookingObj.ID_PROOF === null ||
      templeBookingObj.ID_PROOF === undefined ||
      templeBookingObj.ID_PROOF === "" ||
      templeBookingObj.iDProofNo === null ||
      templeBookingObj.iDProofNo === undefined ||
      templeBookingObj.iDProofNo === ""
    ) {
      isValid = true;
      setError(true);
    } else if ((templeBookingObj.contactNumber !== null && templeBookingObj.contactNumber !== undefined && templeBookingObj.contactNumber !== '') && templeBookingObj.contactNumber?.length !== 10) {
      isValid = true;
      setError(true);
    } else if (templeBookingObj.iDProofNo !== null && templeBookingObj.iDProofNo !== undefined && templeBookingObj.iDProofNo?.length <= 10 && !handlePanInput(templeBookingObj.iDProofNo)) {
      isValid = true;
      setError(true);
    }
    // Validate each member's details
    // Validate number of seats is valid
    if (isNaN(numSeats) || numSeats < 0) {
      // Changed to < 0
      isValid = true;
      setError(true);
    }


    if (numSeats === 0) {
      // If seats are 0, ensure no members exist
      if (
        templeBookingObj.templeDarshanSeatMapping &&
        templeBookingObj.templeDarshanSeatMapping.length > 0
      ) {
        isValid = true;
        setError(true);
      }
    } else if (numSeats > 0) {
      // Validate members when seats are positive
      if (
        !templeBookingObj.templeDarshanSeatMapping ||
        (Number(templeBookingObj.noOfSeats) > 1 && templeBookingObj.templeDarshanSeatMapping.length !== Number(templeBookingObj.noOfSeats))
      ) {
        isValid = true;
        setError(true);
      }

      templeBookingObj.templeDarshanSeatMapping?.forEach((member) => {
        if (
          member.name === null ||
          member.name === "" ||
          member.name === undefined ||
          member.age === null ||
          member.age === undefined ||
          member.age === "" ||
          member.genderID === "" ||
          member.genderID === null ||
          member.genderID === undefined
        ) {
          isValid = true;
          setError(true);
        }
      });
    }

    if (!isValid) {
      if (Number(templeBookingObj?.noOfSeats) === 1) {
        setTempleBookingObj((prev) => ({
          ...prev,
          templeDarshanSeatMapping: [
            ...prev.templeDarshanSeatMapping,
            {
              name: prev.personName || "",
              age: prev.AGE || "",
              genderID: prev.GENDERID || ""
            }
          ]
        }));
      }

      if (!isValid) {

        handleRazorpayPayment()
      }
      // alert(JSON.stringify(templeBookingObj))
    }
  };

  const handleRazorpayPayment = async () => {
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    let minPayableAmount = modelRequestData.amountEntered
      ? modelRequestData.amountEntered
      : Number(totalPrice1);

    let orderIDReturned = null;
    const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)
    setLoader(true)

    if (PlaceOrderResponse?.status === 1) {

      try {
        const response = await AddUpdateTempleDarshanBooking({
          userKeyID: userKeyID,
          darshanBookingKeyID: null,
          noOfSeats: templeBookingObj.noOfSeats,
          address: templeBookingObj?.address,
          templeDarshanID: location?.state?.templeDarshanID,
          darshanPrice: templeBookingObj?.darshanPrice,
          iDProofNo: templeBookingObj.iDProofNo,
          idProofID: templeBookingObj?.ID_PROOF,
          paymentTypeID: modelRequestData.amountEntered ? 1 : 2,
          darshanTimeSlotMapID: templeBookingObj?.darshanTimeSlotMapID,
          taxAmount: 18,
          convenienceFee: location.state.convenienceFee,
          convenienceTaxPercent: location.state?.convinienceFeeTaxPercent,
          paymentStatus:
            minPayableAmount == totalPrice1 ? true : false,
          transactionID: PlaceOrderResponse?.razorpay_payment_id,
          transactionAmount: minPayableAmount,
          couponCodeID: appliedCoupon?.couponCodeID,
          couponCodeAmount: appliedCoupon?.couponAmount,
          walletAmount: appliedCoupon?.walletAmount,
          applicationType: "webapp",
          paymentTypeID: modelRequestData.amountEntered ? 1 : 2,
          templeDarshanSeatMapping: templeBookingObj.templeDarshanSeatMapping,
          bookingDate: templeBookingObj?.bookingDate
        })

        if (response?.statusCode === 200) {

          setShowCODModal(false);
          setLoader(false);

          navigate("/thank-you", {
            state: { moduleName: "DarshanBooking" },
          });

        } else {
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        console.log(error);
      }
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false)
      alert('Order Failed !')
    }
  };



  const handleToDateChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue).format("YYYY-MM-DD");
      setTempleBookingObj((prev) => ({ ...prev, bookingDate: newToDate }));
    } else {
      setTempleBookingObj((prev) => ({ ...prev, bookingDate: null }));
    }
  };

  const handleIdProofChange = (selectedOption) => {
    setSelectedIdProof(selectedOption.value);
    setTempleBookingObj((prev) => ({
      ...prev,
      ID_PROOF: selectedOption.value,
    }));
  };



  useEffect(() => {
    GetMyBookPanditCategoryData();
    GetUserWalletAmountData()
  }, []);



  const GetMyBookPanditCategoryData = async () => {
    try {
      let response = await GetTimeSlotLookupList();

      if (response?.statusCode === 200) {

        const employeeList = response.responseData.data || [];


        const formattedEmployees = employeeList.map((emp) => ({
          value: emp.timeSlotID,
          label: emp.timeSlot
        }));
        setTimeSlotOption(formattedEmployees);
      } else {
        console.error('Failed to fetch employee list');
      }
    } catch (error) {
      console.error('Error fetching employee list:', error);
    }
  };

  const handleTimeSlotChange = (selectedOption) => {

    if (selectedOption) {
      setTempleBookingObj((prev) => ({
        ...prev,
        darshanTimeSlotMapID: selectedOption.value,
      }));
    } else {
      // Handle clearing of selection
      setTempleBookingObj((prev) => ({
        ...prev,
        darshanTimeSlotMapID: null,
      }));
    }
  };

  const handleAddMembers = (value) => {

    const numSeats = parseInt(templeBookingObj.noOfSeats, 10);

    if (numSeats > 0) {
      const membersArray = Array.from({ length: numSeats - 1 }, () => ({
        name: "",
        age: "",
        genderID: null,
      }));

      setTempleBookingObj((prev) => ({
        ...prev,
        templeDarshanSeatMapping: [
          {
            name: prev.personName || "",
            age: prev.AGE || "",
            genderID: prev.GENDERID || "",
            darshanBookingID: null,
          },
          ...membersArray, // ✅ spread to flatten the array
        ],
      }));
      setShowMembers(true);
    }




  };

  const handleMemberChange = (index, field, value) => {

    const updatedMembers = [...templeBookingObj.templeDarshanSeatMapping];
    updatedMembers[index][field] = value;

    setTempleBookingObj((prev) => ({
      ...prev,
      templeDarshanSeatMapping: updatedMembers,
    }));
  };
  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userKeyID); // Replace with actual import/function call
      if (response?.statusCode === 200) {
        setLoader(false);

        const list = response?.responseData?.data
        setWalletAmount(Number(list) <= 0 ? 0 : list)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };


  const handleOpenCoupenModal = () => {

    setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
    setShowModal(true)
  }

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }

  const handlePanInput = (value) => {
    debugger
    // Remove leading spaces
    let cleaned = value.trimStart();

    // Convert to uppercase
    cleaned = cleaned.toUpperCase();

    // PAN regex
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    return panRegex.test(cleaned)

  };

  return (
    <div className="container my-5" style={{ display: "flex", flexDirection: "column" }}>
      <h4 className='text-center'>{location?.state.templeDarshanName} {t("Temple Booking Form")}</h4>
      {/* Step Indicator */}


      {/* Step Content */}
      <div className=" p-4 shadow">

        <div className="row">
          <div className="col-md-8 col-sm-12 mb-3">
            <fieldset className="border rounded p-3">
              <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                {t("Booking Form")}
              </legend>
              <div className="row justify-content-left" style={{ justifyContent: "left" }}>


                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">
                  <label htmlFor="bookingDate" style={{ textAlign: "left" }}>
                    Date
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <DatePicker
                    id="bookingDate"
                    value={templeBookingObj?.bookingDate || ""}
                    minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                    clearIcon={null}
                    onChange={handleToDateChange}
                    format="dd/MM/yyyy"
                  />
                  {error && !templeBookingObj.bookingDate && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>
                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">
                  <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                    Time
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <Select
                    options={timeSlotOption}
                    value={
                      timeSlotOption.find(
                        (option) => option.value === templeBookingObj.darshanTimeSlotMapID
                      ) || null
                    }
                    onChange={handleTimeSlotChange}
                    placeholder="Select Time Slot"
                    styles={customSelectStyles}
                    isClearable
                  />

                  {error && !templeBookingObj.darshanTimeSlotMapID && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>



                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">
                  <label htmlFor="NameUser" style={{ textAlign: "left" }}>
                    Name
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="NameUser"
                    type="text"
                    className="custom-form-control"
                    maxLength={70}
                    value={templeBookingObj.personName || ""}
                    onChange={(e) => {
                      // handleAddMembers(false)
                      let inputVal = e.target.value.trimStart();
                      // handleMemberChange(0, "name", inputVal)
                      const updatedValue = inputVal.replace(/[^a-zA-Z\s]/g, ""); // Allows only characters and spaces
                      setTempleBookingObj((prev) => {
                        const updatedBookingDetails = [...prev.templeDarshanSeatMapping];

                        if (updatedBookingDetails.length > 0) {
                          updatedBookingDetails[0] = {
                            ...updatedBookingDetails[0],
                            name: updatedValue, // 👈 update only name
                          };
                        }

                        return {
                          ...prev,
                          personName: updatedValue,
                          templeDarshanSeatMapping: updatedBookingDetails,
                        };
                      });

                    }}
                    placeholder="Enter name"
                  />
                  {error && !templeBookingObj.personName && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>

                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  <label htmlFor="address" style={{ textAlign: "left" }}>
                    Address
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <textarea
                    id="address"
                    className="custom-form-control"
                    value={templeBookingObj.address || ""}
                    onChange={(e) => {
                      let inputVal = e.target.value.trimStart();
                      setTempleBookingObj((prev) => ({
                        ...prev,
                        address: inputVal,
                      }));
                    }}
                    placeholder="Enter Address"
                  />
                  {error && !templeBookingObj.address && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>


                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  <label htmlFor="state" style={{ textAlign: "left" }}>
                    Contact Number
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="state"
                    maxLength={10}
                    type="text"
                    className="custom-form-control"
                    placeholder="Enter Contact Number"
                    value={templeBookingObj.contactNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      let FormattedNumber = value.replace(/[^0-9]/g, ""); // Allows only numbers

                      // Apply regex to ensure the first digit is between 6 and 9
                      FormattedNumber = FormattedNumber.replace(/^[0-5]/, "");
                      setTempleBookingObj((prev) => ({
                        ...prev,
                        contactNumber: FormattedNumber,
                      }));
                    }}
                  />
                  {error && !templeBookingObj.contactNumber ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : error && ((templeBookingObj.contactNumber !== null && templeBookingObj.contactNumber !== undefined && templeBookingObj.contactNumber !== '') && templeBookingObj.contactNumber?.length !== 10) ?
                    <span style={{ color: "red", fontSize: "small" }}>
                      Contact Number should be 10 digit
                    </span> : ''
                  }
                </div>
                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  <label htmlFor="IdProof" style={{ textAlign: "left" }}>
                    Select Id Proof
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={SelectIdProof}
                    onChange={handleIdProofChange}
                    value={SelectIdProof.find(
                      (item) => item.value === selectedIdProof
                    )}
                    placeholder="Select
                  Id Proof"
                  />
                  {error &&
                    (selectedIdProof === null ||
                      selectedIdProof === undefined ||
                      selectedIdProof === "") ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                {/* Conditional Input Field */}
                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  {selectedIdProof === 2 && (
                    <>
                      <label htmlFor="panCard" style={{ textAlign: "left" }}>
                        Enter PAN No.{" "}
                        <span style={{ color: "red", fontSize: "small" }}>
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        maxLength={10}
                        className="custom-form-control"
                        placeholder="Enter PAN Card Number"
                        value={templeBookingObj.iDProofNo || ""}
                        onChange={(e) => {
                          let InputValue = e.target.value;

                          // Prevent the first character from being a space
                          if (InputValue.startsWith(" ")) {
                            InputValue = InputValue.trimStart(); // Remove leading space
                          }
                          const formatedNumber = InputValue.toUpperCase();
                          setTempleBookingObj((prev) => ({
                            ...prev,
                            iDProofNo: formatedNumber,
                          }));
                        }}
                      />
                      {error &&
                        (templeBookingObj.iDProofNo === null ||
                          templeBookingObj.iDProofNo === undefined ||
                          templeBookingObj.iDProofNo === "") ? (
                        <span style={{ color: "red", fontSize: "small" }}>
                          {ERROR_MESSAGES}
                        </span>
                      ) : (error && templeBookingObj.iDProofNo?.length <= 10 && !handlePanInput(templeBookingObj.iDProofNo)) ? <span style={{ color: "red", fontSize: "small" }}>
                        Invalid PAN Number
                      </span> : (
                        ""
                      )}
                    </>
                  )}

                  {selectedIdProof === 1 && (
                    <>
                      <label htmlFor="adharCard" style={{ textAlign: "left" }}>
                        Enter Aadhaar No{" "}
                        <span style={{ color: "red", fontSize: "small" }}>
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        maxLength={14}
                        className="custom-form-control"
                        placeholder="Enter Aadhaar Number"
                        value={templeBookingObj.iDProofNo || ""}
                        onChange={(e) => {
                          let value = e.target.value;
                          let FormattedNumber = value.replace(/[^0-9]/g, "");
                          value = FormattedNumber.replace(/(.{4})/g, "$1 ").trim();
                          setTempleBookingObj((prev) => ({
                            ...prev,
                            iDProofNo: value,
                          }));
                        }}
                      />
                      {error &&
                        (templeBookingObj.iDProofNo === null ||
                          templeBookingObj.iDProofNo === undefined ||
                          templeBookingObj.iDProofNo === "") ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "small",
                            fontSize: "small",
                          }}
                        >
                          {ERROR_MESSAGES}
                        </span>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>

                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  <label htmlFor="noOfSeats" style={{ textAlign: "left" }}>
                    age
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="noOfSeats"
                    type="text"
                    maxLength={2}
                    className="custom-form-control"
                    value={templeBookingObj.AGE || ""}
                    onChange={(e) => {
                      let inputVal = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                      // handleMemberChange(
                      //   1,
                      //   "age",
                      //   inputVal
                      // )
                      setTempleBookingObj((prev) => {
                        const updatedBookingDetails = [...prev.templeDarshanSeatMapping];

                        if (updatedBookingDetails.length > 0) {
                          updatedBookingDetails[0] = {
                            ...updatedBookingDetails[0],
                            age: inputVal, // 👈 update only name
                          };
                        }

                        return {
                          ...prev,
                          AGE: inputVal,
                          templeDarshanSeatMapping: updatedBookingDetails,
                        };
                      });


                    }}
                    placeholder="Enter age"
                  />
                  {error && !templeBookingObj.AGE && (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  )}
                </div>
                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  <label htmlFor="bookingTime" style={{ textAlign: "left" }}>
                    Gender
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <Select
                    styles={customSelectStyles}
                    options={genderOptions}
                    placeholder="Select Gender"
                    isClearable
                    value={genderOptions.find(
                      (option) => option.value === templeBookingObj.GENDERID
                    )}
                    onChange={handleGenderChange}
                  />

                  {error &&
                    (templeBookingObj.GENDERID === null ||
                      templeBookingObj.GENDERID === undefined ||
                      templeBookingObj.GENDERID === "") ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-4 col-sm-6 mb-2 d-flex flex-column form-font-size">

                  <label htmlFor="noOfSeats" style={{ textAlign: "left" }}>
                    No of Seats
                    <span style={{ color: "red", fontSize: "small" }}>*</span>
                  </label>
                  <input
                    id="noOfSeats"
                    type="text"
                    maxLength={1}
                    className="custom-form-control"
                    value={templeBookingObj.noOfSeats || ""}
                    onChange={(e) => {
                      let inputVal = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
                      if (inputVal < 4) {
                        setTempleBookingObj((prev) => ({
                          ...prev,
                          noOfSeats: inputVal,
                          templeDarshanSeatMapping: [], // Reset members if seats change
                        }));
                      }

                      setShowMembers(false); // Reset members input if seats change
                    }}
                    placeholder="Enter No of Seats"
                  />
                  {error && !templeBookingObj.noOfSeats ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      {ERROR_MESSAGES}
                    </span>
                  ) : error && templeBookingObj.noOfSeats <= 0 ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      Please enter valid number of seats.
                    </span>
                  ) : (error && (
                    !templeBookingObj.templeDarshanSeatMapping ||
                    (Number(templeBookingObj.noOfSeats) > 1 && templeBookingObj.templeDarshanSeatMapping.length !== Number(templeBookingObj.noOfSeats))
                  )) ? (
                    <span style={{ color: "red", fontSize: "small" }}>
                      Please Add Visitor Details
                    </span>
                  ) : ''}
                </div>

                <div className="col-md-3 col-sm-6 mb-2 d-flex flex-column"></div>
                {Number(templeBookingObj.noOfSeats) > 1 && Number(templeBookingObj.noOfSeats) !== templeBookingObj?.templeDarshanSeatMapping?.length && (
                  <div className="row justify-content-center">
                    <div className="col-md-3 text-center">
                      <button
                        className="Normal-app-btn"
                        style={{ padding: "5px 16px", fontSize: "15px" }}
                        onClick={handleAddMembers}
                      >
                        Add Visitors
                      </button>
                    </div>
                  </div>
                )}

                {showMembers && (
                  <div className="row justify-content-center mt-3">
                    {templeBookingObj.templeDarshanSeatMapping.map(
                      (member, index) => (
                        <div key={index} className="col-md-9 d-flex gap-2 mb-2">
                          {/* name Input */}
                          <div style={{ width: "100%" }}>
                            <input
                              type="text"
                              maxLength={25}
                              className="custom-form-control"
                              placeholder={`Member ${index + 1} name`}
                              value={member?.name}
                              disabled={index === 0}
                              onChange={(e) => {
                                let InputValue = e.target.value;

                                // Prevent the first character from being a space
                                if (InputValue.startsWith(" ")) {
                                  InputValue = InputValue.trimStart(); // Remove leading space
                                }
                                const updatedValue = InputValue.replace(
                                  /[^a-zA-Z\s]/g,
                                  ""
                                ); // Allows only characters and spaces
                                handleMemberChange(index, "name", updatedValue);
                              }}
                            />
                            {error && !member?.name && (
                              <span style={{ color: "red", fontSize: "small" }}>
                                {ERROR_MESSAGES}
                              </span>
                            )}
                          </div>

                          {/* age Input */}
                          <div style={{ width: "100%" }}>
                            <input
                              type="text"
                              maxLength={2}
                              className="custom-form-control"
                              placeholder="age"
                              value={member?.age}
                              disabled={index === 0}
                              onChange={(e) =>
                                handleMemberChange(
                                  index,
                                  "age",
                                  e.target.value.replace(/\D/g, "")
                                )
                              }
                            />
                            {error && !member?.age && (
                              <span style={{ color: "red", fontSize: "small" }}>
                                {ERROR_MESSAGES}
                              </span>
                            )}
                          </div>

                          {/* genderID Dropdown */}
                          <div style={{ width: "100%" }}>
                            <Select
                              styles={customSelectStyles}
                              className="react-select-container"
                              classNamePrefix="react-select"
                              options={genderOptions}
                              placeholder="Select Gender"
                              isClearable
                              value={genderOptions.find(
                                (option) => option.value === member.genderID
                              )}
                              isDisabled={index === 0}
                              onChange={(selectedOption) =>
                                handleMemberChange(
                                  index,
                                  "genderID",
                                  selectedOption ? selectedOption.value : null
                                )
                              }

                            />
                            {error && !member.genderID && (
                              <span style={{ color: "red", fontSize: "small" }}>
                                {ERROR_MESSAGES}
                              </span>
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}





              </div>
            </fieldset>
          </div>

          <div className="col-md-4 col-sm-12 mb-3">
            <fieldset className="border rounded p-3">
              <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                {t("Payment Summary")}
              </legend>
              <div >
                <div className="price-summary">

                  <ul>

                    <li>
                      <span>
                        Price ( ₹ {location?.state?.darshanPrice}/person)

                      </span>
                      <span>
                        {formatToIndianCurrency(
                          Math.round(totals?.totalPrice)
                        )}
                      </span>
                    </li>
                    {isWalletApplied && appliedCoupon?.isApplied === false ? (
                      <li style={{ fontSize: 'smaller' }}>
                        <span>
                          Applied Wallet Amount (₹)

                        </span>
                        <span>
                          {appliedCoupon?.walletAmount}
                        </span>
                      </li>
                    ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                      <li style={{ fontSize: 'smaller' }}>
                        <span>
                          Applied Coupon  Amount (₹)

                        </span>
                        <span>
                          {couponAmount}
                        </span>
                      </li>
                    ) : ''}

                    {/* <hr></hr> */}
                    {/* productBookingData.needSamagri === "yes" */}



                    <li>
                      <span>Convenience Fee (₹):</span>
                      <span>
                        {Math.round(totals?.totalConvienceFee)}

                      </span>
                    </li>
                    <hr />


                    <li>
                      <span>Grand Total (₹):</span>
                      <span>
                        {" "}
                        {formatToIndianCurrency(Math.round(totalPrice1))}
                      </span>
                    </li>



                  </ul>
                  <div className='border rounded p-2 mb-2'>
                    {/* Wallet */}
                    {walletAmount !== 0 && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            <i className="bi bi-wallet2 fs-5 me-2 text-primary-custom"></i>
                            <div style={{ lineHeight: "1.2" }}>
                              <strong className="small" style={{ fontWeight: "600", color: "grey" }}>{t("Use Wallet Balance")}</strong><br />
                              <small className="text-muted">{t("Available")}: ₹ {isWalletApplied ? walletAmount - appliedCoupon?.walletAmount : walletAmount}</small>
                            </div>
                          </div>
                          {isWalletApplied ? (
                            <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {

                              setIsWalletApplied(!isWalletApplied)
                            }
                            }>{t("Remove Wallet")}</button>
                          ) : (
                            <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {
                              setAppliedCoupon((PREV) => ({
                                ...PREV, couponCode: null,
                                isApplied: false
                              }))
                              setIsWalletApplied(!isWalletApplied)
                              setAppliedCoupon((prev) => ({
                                ...prev, couponCode: null,
                                isApplied: false,
                                couponAmount: 0,
                                walletAmount: 0
                              }))
                            }
                            }>{t("Apply Wallet")}</button>
                          )}

                        </div>
                        <div className="d-flex align-items-center mb-2" style={{ fontSize: "13px" }}>
                          <hr className="flex-grow-1 my-1" />
                          <span className="px-2 text-muted">{t("or")}</span>
                          <hr className="flex-grow-1 my-1" />
                        </div>
                      </>

                    )}


                    {/* Coupons */}
                    <div className="input-group input-group-sm mb-2 ">

                      {appliedCoupon?.isApplied ? (
                        <div

                          style={{

                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            // fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                            <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                            {appliedCoupon && (
                              <>
                                <span
                                  style={{
                                    border: '1px dotted #333',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    backgroundColor: '#fff',
                                    color: '#333',
                                    marginLeft: '6px',
                                  }}
                                >
                                  {appliedCoupon?.couponCode}
                                </span>

                              </>


                            )}
                          </div>
                          <span
                            onClick={() => {
                              setAppliedCoupon((prev) => ({
                                ...prev, couponCode: null,
                                isApplied: false,
                                couponAmount: 0,
                                walletAmount: 0
                              }))
                              setAppliedCoupon((prev) => ({
                                ...prev, couponCode: null,
                                isApplied: false,
                                couponAmount: 0,
                                walletAmount: 0
                              }))
                            }}
                            style={{
                              // border: '1px dotted #333',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              backgroundColor: '#fff',
                              color: '#a52444',
                              marginLeft: '6px',
                            }} >



                            Remove

                          </span>
                          <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                        </div>
                      ) : (
                        <div className='border border-1'
                          onClick={() => handleOpenCoupenModal()}
                          style={{

                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            // fontWeight: 'bold',
                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                              backgroundColor: '#a52444',
                              color: 'white',
                              borderRadius: '50%',
                              width: '24px',
                              height: '24px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '14px',
                              marginRight: '10px',

                            }}>
                              %
                            </div>
                            <span style={{ fontWeight: '400' }}>{t("View Coupons & Offers")}</span>

                          </div>
                          {/* <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span> */}
                        </div>
                      )}

                    </div>
                    {/* <hr className="flex-grow-1 my-3" /> */}
                  </div>
                  <div className="mt-3 d-flex justify-content-end gap-2">



                    <button
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      className="Normal-app-btn"
                      onClick={HandleTempleDarshanBookingBtnClicked}
                    // onClick={handleRazorpayPayment}
                    >
                      Pay Now
                    </button>

                  </div>
                </div>

              </div>
            </fieldset>
          </div>


        </div>





      </div>





      <TempleCodModal
        show={showCODModal}
        onHide={() => setShowCODModal(false)}
        onConfirm={handleRazorpayPayment}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
      />
      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        apiParam={couponObj} />
    </div>
  );
};

export default TempleBookingForm;
